import React from 'react';

const DateSelector = ({ selectedDate }) => {
  return (
    <div className='tickets-date-selector d-flex justify-content-between align-items-center w-100'>
      <div className='tickets-date-display'>
        <h2 className='m-0 tickets-date-text'>{selectedDate}</h2>
      </div>
      <button className='tickets-today-btn border rounded-lg px-4 py-2 d-flex align-items-center'>
        <span>{selectedDate}</span>
        <svg
          className='ml-2'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='20' height='20' rx='4' fill='#E2E8F0' />
          <path
            d='M15 4H5C3.89543 4 3 4.89543 3 6V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V6C17 4.89543 16.1046 4 15 4Z'
            stroke='#64748B'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14 2V6'
            stroke='#64748B'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6 2V6'
            stroke='#64748B'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3 10H17'
            stroke='#64748B'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
    </div>
  );
};

export default DateSelector;
